import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  RDS_DIALOG_DATA,
  RdsButtonComponent,
  RdsDialogActionsContainerDirective,
  RdsDialogCloseDirective,
  RdsDialogContentDirective,
  RdsDialogHeaderDirective,
} from '@rds/angular-components';

export interface ConfirmationData {
  header?: string;
  message?: string;
  reject?: string;
  accept?: string;
  hideReject?: boolean;
}

@Component({
  selector: 'bsh-confirmation',
  imports: [
    RdsDialogHeaderDirective,
    RdsDialogContentDirective,
    RdsDialogActionsContainerDirective,
    RdsButtonComponent,
    RdsDialogCloseDirective,
  ],
  templateUrl: './confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent {
  protected readonly data = inject(RDS_DIALOG_DATA) as ConfirmationData;
}
